import React from "react";
import { CircleMarker, Tooltip, useMapEvents } from "react-leaflet";

export function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}

export function interpolateColor(start, end, t) {
    const ratio = clamp(t, 0, 1);
    const r = Math.round(start.r + (end.r - start.r) * ratio);
    const g = Math.round(start.g + (end.g - start.g) * ratio);
    const b = Math.round(start.b + (end.b - start.b) * ratio);
    return `rgb(${r}, ${g}, ${b})`;
}

export function getDepthColor(depth) {
    const thresholdDepth = 7;
    const white = { r: 255, g: 255, b: 255 };
    const blue = { r: 10, g: 47, b: 112 };
    const red = { r: 220, g: 38, b: 38 };

    if (!Number.isFinite(depth)) return "rgb(255, 255, 255)";
    if (depth <= thresholdDepth) {
        const t = depth <= 0 ? 0 : depth / thresholdDepth;
        return interpolateColor(white, blue, t);
    }

    return interpolateColor(blue, red, (depth - thresholdDepth) / thresholdDepth);
}

export function MapDepthViewportListener({ onViewportChange }) {
    const map = useMapEvents({
        load() {
            const bounds = map.getBounds();
            onViewportChange?.({
                bounds: {
                    north: bounds.getNorth(),
                    south: bounds.getSouth(),
                    east: bounds.getEast(),
                    west: bounds.getWest(),
                },
                zoom: map.getZoom(),
            });
        },
        moveend() {
            const bounds = map.getBounds();
            onViewportChange?.({
                bounds: {
                    north: bounds.getNorth(),
                    south: bounds.getSouth(),
                    east: bounds.getEast(),
                    west: bounds.getWest(),
                },
                zoom: map.getZoom(),
            });
        },
        zoomend() {
            const bounds = map.getBounds();
            onViewportChange?.({
                bounds: {
                    north: bounds.getNorth(),
                    south: bounds.getSouth(),
                    east: bounds.getEast(),
                    west: bounds.getWest(),
                },
                zoom: map.getZoom(),
            });
        },
    });
    return null;
}

export default function SonarDepthLayer({ points }) {
    return points.map((point) => {
        const lat = Number(point?.lat);
        const lng = Number(point?.lng);
        const depth = Number(point?.depth);
        if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
        const isOverview = Boolean(point?.overview || point?.clustered);
        if (isOverview) {
            return (
                <CircleMarker
                    key={`depth-overview-${point.id ?? `${lat}-${lng}`}`}
                    center={[lat, lng]}
                    radius={5}
                    bubblingMouseEvents={false}
                    pathOptions={{ color: "#9ca3af", fillColor: "#9ca3af", fillOpacity: 0.35, weight: 1 }}
                />
            );
        }
        const fillColor = getDepthColor(depth);

        return (
            <CircleMarker
                key={`depth-${point.id ?? `${lat}-${lng}`}`}
                center={[lat, lng]}
                radius={4}
                bubblingMouseEvents={false}
                pathOptions={{ color: fillColor, fillColor, fillOpacity: 0.95, weight: 1 }}
            >
                <Tooltip direction="top" offset={[0, -6]}>
                    {`Глубина: ${Number.isFinite(depth) ? depth : "-"} м`}
                </Tooltip>
            </CircleMarker>
        );
    });
}
